const DashboardPage = () => {
    return (
        <div className="page_wrapper px-4 py-5">
            <h1></h1>
        </div>
    )
}

export default DashboardPage;